/**
 * 전역 상수.
 *
 * 라벨·색상·코드 매핑을 컴포넌트에 흩어놓지 않는다.
 * 같은 값이 화면마다 다른 이름으로 표시되는 것을 막기 위함이다.
 *
 * 도메인 전용 상수는 features/<domain>/ 아래에 둔다.
 * 여기에는 여러 도메인이 함께 쓰는 것만 넣는다.
 */

/** 시장 코드. 백엔드가 내려주는 값과 맞춘다. */
export const MARKET = {
  KOSPI: 'KOSPI',
  KOSDAQ: 'KOSDAQ',
  NASDAQ: 'NASDAQ',
  NYSE: 'NYSE',
} as const;

export type Market = (typeof MARKET)[keyof typeof MARKET];

export const MARKET_LABEL: Record<Market, string> = {
  KOSPI: '코스피',
  KOSDAQ: '코스닥',
  NASDAQ: '나스닥',
  NYSE: '뉴욕',
};

/** 국내 시장인지 판단한다. 통화 표시와 장 운영시간 판단이 갈린다. */
export function isDomesticMarket(market: Market): boolean {
  return market === MARKET.KOSPI || market === MARKET.KOSDAQ;
}

/**
 * 데이터 갱신 주기(ms).
 *
 * 보유 종목 현재가는 백엔드 배치가 평일 09:00~15:30에 5분 간격으로 갱신한다.
 * (00-architecture.md 5절) 프론트가 그보다 자주 물어봐야 새 값이 없으므로
 * 백엔드 주기에 맞춘다.
 */
export const REFRESH_INTERVAL = {
  /** 보유 종목 시세 */
  QUOTE: 5 * 60 * 1000,
  /** 헬스체크 / 모니터링 지표 */
  HEALTH: 30 * 1000,
} as const;

/**
 * TanStack Query 기본 옵션.
 *
 * staleTime을 0으로 두면 화면을 전환할 때마다 재요청이 나간다.
 * 사용자 1명 시스템에서 그럴 이유가 없고, 홈서버 부하만 는다.
 */
export const QUERY_DEFAULTS = {
  /** 이 시간 동안은 캐시를 신선한 것으로 본다. */
  staleTime: 60 * 1000,
  /** 캐시를 메모리에 유지하는 시간. */
  gcTime: 5 * 60 * 1000,
} as const;

/** 화면에 값이 없을 때 표시하는 문자열. format.ts와 같은 값을 쓴다. */
export const EMPTY_TEXT = '-';
